import StandardQueryTable from "@/components/StandardQueryTable";
import { EntityListLink } from "@/components/EntityListLink";
import TaxStatus from "@/components/TaxStatus";
import { Module, PATH_CONTRACTOR } from "@/constants";
import { readContractorStudent } from "@/schemas/contractorStudent";
import { fetchContractorStudentsList } from "@/services/contractorStudents";
import { ReadContractorStudent } from "@/types/contractorStudent";
import { Row } from "@tanstack/react-table";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

const ContractorStudentsList = () => {
  const { t } = useTranslation();

  const columnOverrides = useMemo(
    () => ({
      full_name: {
        id: "full_name",
        cell: ({ row }: { row: Row<ReadContractorStudent> }) => (
          <div className="flex items-center h-full pl-2 pr-2">
            <span className="flex-1 truncate">{row.original.full_name}</span>
            <EntityListLink
              path={generatePath(PATH_CONTRACTOR, {
                contractorId: row.original.id,
              })}
              label={row.original.full_name}
              target="_blank"
              className="h-6 w-6 hover:bg-transparent hover:opacity-70"
            />
          </div>
        ),
      },
      tax_status: {
        id: "tax_status",
        cell: ({ row }: { row: Row<ReadContractorStudent> }) => (
          <TaxStatus value={row.original.tax_status} />
        ),
      },
      days_until_26_birthday: {
        id: "tax_status",
        cell: ({ row }: { row: Row<ReadContractorStudent> }) =>
          row.original.days_until_26_birthday,
      },
    }),
    [],
  );

  const getRowProps = useCallback(
    <T,>({ original }: { original: T }): Record<string, unknown> => {
      const { days_until_26_birthday } = original as ReadContractorStudent;
      const days = -days_until_26_birthday;

      if (days <= 0) {
        return { className: "bg-red-50 hover:bg-red-100" };
      }

      if (days <= 30) {
        return { className: "bg-orange-50 hover:bg-orange-100" };
      }

      return {};
    },
    [],
  );

  const tableFeatures = useMemo(
    () => ({
      getRowProps,
      exportSettings: { moduleName: Module.ContractorStudents },
    }),
    [getRowProps],
  );

  return (
    <StandardQueryTable<ReadContractorStudent>
      schema={readContractorStudent}
      name="contractorStudents"
      translationKey="contractorStudents"
      fetchList={fetchContractorStudentsList}
      tableFeatures={tableFeatures}
      columnOverrides={columnOverrides}
      actions={[]}
    />
  );
};

export default ContractorStudentsList;
